export default {
      id: "book-structure-usage",
      viewBox: "0 0 16 10",
      url: __webpack_public_path__ + "sprite.svg#book-structure-usage",
      toString: function () {
        return this.url;
      }
    }